import { makeAutoObservable } from 'mobx';
import mixpanel from 'mixpanel-browser';

class PricingStore {
  showOnlyPro = false;
  isHighIncome = false;

  constructor() {
    makeAutoObservable(this);
    this.initializePricing();
  }

  initializePricing() {
    // Check URL parameters for pricing variant
    const urlParams = new URLSearchParams(window.location.search);
    const pricingVariant = urlParams.get('utm_pricing');
    
    if (pricingVariant === 'hi') {
      this.isHighIncome = true;
      this.showOnlyPro = true; // Always show pro-only for high income
    } else {
      // Always show pro-only
      this.showOnlyPro = true;
    }

    // Set utm_pricing in mixpanel for all variants
    const utm_pricing = this.isHighIncome ? 'high_income' : (this.showOnlyPro ? 'pro_only' : 'all_plans');
    
    // Track pricing variant in mixpanel
    mixpanel.people.set({
      utm_pricing: utm_pricing,
      checkoutPricing: utm_pricing
    });

    // Track the pricing variant assignment
    mixpanel.track('Pricing Variant Assigned', {
      variant: utm_pricing
    });
  }

  get proMonthlyPrice() {
    return this.isHighIncome ? 19.99 : 9.99;
  }

  get proYearlyPrice() {
    return this.isHighIncome ? 199.99 : 69.99;
  }

  get basicMonthlyPrice() {
    return 4.99;
  }

  get basicYearlyPrice() {
    return 49.99;
  }

  get defaultSubscriptionType() {
    if (this.isHighIncome) return 'pro-monthly-hi';
    if (this.showOnlyPro) return 'pro-yearly-discount';
    return 'pro-monthly';
  }

  get proYearlySlug() {
    return this.isHighIncome ? 'pro-yearly-hi' : 'pro-yearly-discount';
  }

  get proMonthlySlug() {
    return this.isHighIncome ? 'pro-monthly-hi' : 'pro-monthly';
  }
}

const pricingStore = new PricingStore();
export default pricingStore; 